export const useContacts = () => {
  const { t } = useI18n()

  const countries = [
    {
      title: t('aboutCompany.contact.bg.title'),
      flag: '/images/about-company/flags/bg.svg',
      phone: t('aboutCompany.contact.bg.phone'),
      email: t('aboutCompany.contact.bg.email')
    },
    {
      title: t('aboutCompany.contact.hr.title'),
      flag: '/images/about-company/flags/hr.svg',
      phone: t('aboutCompany.contact.hr.phone'),
      email: t('aboutCompany.contact.hr.email')
    },
    {
      title: t('aboutCompany.contact.sk.title'),
      flag: '/images/about-company/flags/sk.svg',
      phone: t('aboutCompany.contact.sk.phone'),
      email: t('aboutCompany.contact.sk.email')
    },
    {
      title: t('aboutCompany.contact.cz.title'),
      flag: '/images/about-company/flags/cz.svg',
      phone: t('aboutCompany.contact.cz.phone'),
      email: t('aboutCompany.contact.cz.email')
    },
    {
      title: t('aboutCompany.contact.tr.title'),
      flag: '/images/about-company/flags/tr.svg',
      phone: t('aboutCompany.contact.tr.phone'),
      email: t('aboutCompany.contact.tr.email')
    }
  ]

  return {
    countries
  }
}